<template>
  <el-table-column
    prop="eu_tax_number"
    sortable
    label="Eu adószám"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.eu_tax_number }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'eu_tax_number',
  };
</script>
